import '@styles/index.css';
import React, { useState } from 'react';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import {
    setEmail,
    setMobileNumber,
    setName,
    setTermsAccepted,
} from '@store/reducers/auth/signupSlice';
import { useTranslation } from 'react-i18next';
import { HOSPITAL } from '@constants/constants';
import ErrorMessage from '@components/Error/ErrorMessage';
import {
    MOBILE_NUMBER_PATTERN,
    MOBILE_NUMBER_TITLE,
    MOBILE_NUMBER_MIN_LENGTH,
    MOBILE_NUMBER_MAX_LENGTH,
    NAME_TEXT_MIN_LENGTH,
    NAME_TEXT_MAX_LENGTH,
    NAME_TEXT_PATTERN,
    NAME_TEXT_TITLE,
    EMAIL_PATTERN,
    EMAIL_TITLE,
    EMAIL_MAX_Length,
} from '@constants/form';
import { PRIVACY_POLICY_PATH, TERMS_AND_CONDITIONS_PATH } from '@constants/routes';

const AccountInfo = () => {
    const userEmail = useAppSelector((state) => state.signup.email);
    const UserMobileNumber = useAppSelector(
        (state) => state.signup.mobileNumber
    );
    const adminName = useAppSelector((state) => state.signup.name);
    const userRole = useAppSelector((state) => state.signup.userRole);
    const [email, setUserEmail] = useState(userEmail);
    // const [adminName, setAdminUserName] = useState('');
    const [mobileNumber, setUserMobileNumber] = useState(UserMobileNumber);
    const [error, setError] = useState<string | null>(null);
    const userTermsAccepted = useAppSelector((state) => state.signup.termsAccepted);
    const [termsAccepted, setTerms] = useState(userTermsAccepted);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserEmail(event.target.value);
        dispatch(setEmail(event.target.value));
        setError(null);
    };

    const handleAdminUserNameChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = event.target.value;
        const regex = /^[A-Za-z\s]*$/;
        if (regex.test(value)) {
            // setAdminUserName(value);
            dispatch(setName(value));
        }
        setError(null);
    };

    const handleMobileNumberChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = event.target.value;
        // Allow only numbers (0-9)
        if (/^\d*$/.test(value) && value.length <= MOBILE_NUMBER_MAX_LENGTH) {
            setUserMobileNumber(value);
            dispatch(setMobileNumber(value));
        }
        setError(null);
    };

    const handleTermsAcceptedChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTerms(event.target.checked);
        dispatch(setTermsAccepted(event.target.checked));
    };
    return (
        <div>
            {error && <ErrorMessage message={error} />}
            {userRole == HOSPITAL && (
                <div className="mb-3">
                    <label
                        htmlFor="administrator_name"
                        className="block mb-2 text-sm font-medium text-light_grey"
                    >
                        {t('auth.signup.admin_name_lable')}
                        <span className="text-red ml-2">*</span>
                    </label>
                    <input
                        type="text"
                        name="administrator_name"
                        id="signup_administrator_name"
                        value={adminName}
                        onChange={handleAdminUserNameChange}
                        className="form-control px-3 py-2 placeholder-custom"
                        placeholder={t('auth.signup.admin_name_placeholder')}
                        minLength={NAME_TEXT_MIN_LENGTH}
                        maxLength={NAME_TEXT_MAX_LENGTH}
                        title={NAME_TEXT_TITLE}
                        pattern={NAME_TEXT_PATTERN}
                        required
                    />
                </div>
            )}
            <div className="">
                <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-light_grey"
                >
                    {t('auth.signup.email_label')}
                    <span className="text-red ml-2">*</span>
                </label>
                <input
                    type="email"
                    name="email"
                    id="signup_email"
                    value={email}
                    onChange={handleEmailChange}
                    className="form-control px-3 py-2 placeholder-custom"
                    placeholder={t('auth.signup.email_placeholder')}
                    pattern={EMAIL_PATTERN}
                    title={EMAIL_TITLE}
                    maxLength={EMAIL_MAX_Length}
                    required
                    autoComplete="off"
                />
            </div>
            <div className="mt-3">
                <label
                    htmlFor="mobile_number"
                    className="block mb-2 text-sm font-medium text-light_grey"
                >
                    {t('auth.signup.mobile_number_label')}
                    <span className="text-red ml-2">*</span>
                </label>
                <input
                    type="text"
                    name="mobile_number"
                    id="mobile_number"
                    value={mobileNumber}
                    onChange={handleMobileNumberChange}
                    className="form-control px-3 py-2 placeholder-custom"
                    placeholder={t('auth.signup.mobile_number_placeholder')}
                    pattern={MOBILE_NUMBER_PATTERN}
                    title={MOBILE_NUMBER_TITLE}
                    minLength={MOBILE_NUMBER_MIN_LENGTH}
                    maxLength={MOBILE_NUMBER_MAX_LENGTH}
                    required
                />
            </div>
            <div className="mt-4 flex items-start gap-2">
                <input
                    type="checkbox"
                    id="termsCheckbox"
                    name="termsCheckbox"
                    checked={termsAccepted}
                    onChange={handleTermsAcceptedChange}
                    className="mt-1"
                    required
                />
                <label htmlFor="termsCheckbox" className="text-sm text-light_grey">
                    {t('auth.terms_condition')}{' '}
                    <a href={TERMS_AND_CONDITIONS_PATH} target="_blank" className="text-blue-500 underline">
                        {t('auth.terms')}
                    </a>{' '}
                    {t('auth.and')}{' '}
                    <a href={PRIVACY_POLICY_PATH} target="_blank" className="text-blue-500 underline">
                        {t('auth.privacy')}
                    </a>
                </label>
            </div>
        </div>
    );
};

export default AccountInfo;
